// GTM dataLayer events. GTM itself is loaded from public/index.html, and only
// on portal.storkplus.com; elsewhere these pushes land in a dataLayer nobody
// reads. Never put plain personal data (email, phone, name) in here — the
// only identity GTM gets is the user id and a SHA-256 of the email.

export const newEventId = () =>
  window.crypto?.randomUUID?.() ??
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

// `params`: extra event parameters (codes and ids only, never personal data).
export const trackEvent = (event, eventId, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    event_id: eventId ? String(eventId) : newEventId(),
    method: "email",
    ...params,
  });
};

// localStorage key read by public/index.html, which pushes it to the dataLayer
// before gtm.js loads so the pixel starts with it (advanced matching). It is a
// session key, so clearSession() removes it on logout.
export const TRACKING_IDENTITY_KEY = "trackingIdentity";

const sha256Hex = async (value) => {
  const digest = await window.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(value)
  );
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

// Hashing is async (crypto.subtle), so it is done here, ahead of time, and
// the inline snippet only has to read the result. The first page after a
// login already has the pixel running; every page load after it carries the
// identity.
export const rememberTrackingIdentity = async (session) => {
  const id = session?.user?.id;
  const email = session?.user?.email;
  if (id === undefined || id === null || !email || !window.crypto?.subtle) {
    return;
  }
  try {
    const identity = {
      user_id: String(id),
      user_email_sha256: await sha256Hex(email.trim().toLowerCase()),
    };
    localStorage.setItem(TRACKING_IDENTITY_KEY, JSON.stringify(identity));
  } catch (error) {
    // Tracking must never break the portal.
  }
};
